/* ========================================================================
   Touch
 ========================================================================== */

app.touch = (function () {
  'use strict';

  let isTouch = false;
  let isTouchClass = 'is-touch';
  let isTouchTimer;

  function addTouchClass() {
    window.clearTimeout(isTouchTimer);
    if (isTouch === true) return;

    isTouchTimer = window.setTimeout(() => {
      document.documentElement.classList.add(isTouchClass);
      isTouch = true;
    }, 250);
  }

  function removeTouchClass() {
    if (isTouch === false) return;

    document.documentElement.classList.remove(isTouchClass);
    isTouch = false;
  }

  function init() {
    document.addEventListener('touchstart', addTouchClass, { passive: true });
    document.addEventListener('mouseover', removeTouchClass);
  }

  // Expose public functions and variables
  return {
    init: init,
  };
})();
